import { SemanticModel } from "@pufflig/prompt-studio-types";
import debounce from "lodash.debounce";
import isEqual from "lodash.isequal";
import { useEffect, useRef } from "react";
import { saveSemanticModel } from "../actions/saveSemanticModel";
import { useSemanticModelStore } from "../state/SemanticModelProvider";
import { SemanticModelStore } from "../state/defaultState";

export const useOnSemanticModelChange = (connectorId?: string, debounceTime?: number) => {
  const prevModelRef = useRef<SemanticModel | null>(null);

  useEffect(() => {
    if (!connectorId) return;

    prevModelRef.current = useSemanticModelStore.getState().semanticModel;

    const handler = debounce(async (state: SemanticModelStore) => {
      const { semanticModel } = state;
      if (!semanticModel) return;
      if (isEqual(semanticModel, prevModelRef.current)) return;
      await saveSemanticModel(connectorId, semanticModel);
      prevModelRef.current = semanticModel;
    }, debounceTime);

    const unsub = useSemanticModelStore.subscribe(handler);

    return () => {
      handler.flush();
      unsub();
    };
  }, [connectorId, debounceTime]);
};
